import axios from "axios";
import { format } from "date-fns";
import { default as React, Fragment, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Accordion, Button, Divider, Form, Header, Icon, Label, List, Loader, Message, Ref, } from "semantic-ui-react";
import styled from "styled-components";
import compareByDayOfTheWeekAndStartTime, { DAY_OF_THE_WEEK_DIC } from "../function/compareByDayOfTheWeekAndStartTime";
import { useCheckbox, useTextInput } from "../hooks/formHooks";
import useQueryString from "../hooks/useQueryString";
const { dataLayer, fbq } = window;
const Component = (props) => (React.createElement("div", { className: props.className }, props.success ? (React.createElement(Message, { success: true },
    React.createElement(Message.Header, null, "\u4F53\u9A13\u7533\u8FBC\u307F\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F"),
    "\u4F53\u9A13\u7533\u3057\u8FBC\u307F\u3092\u3057\u3066\u3044\u305F\u3060\u304D\u3001\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\u3002",
    React.createElement("br", null),
    "\u3054\u5165\u529B\u3057\u3066\u3044\u305F\u3060\u3044\u305F\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306B\u3001 \u78BA\u8A8D\u30E1\u30FC\u30EB\u3092\u9001\u4FE1\u3057\u307E\u3057\u305F\u306E\u3067\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002",
    React.createElement("br", null),
    "\u8FF7\u60D1\u30E1\u30FC\u30EB\u306B\u5206\u985E\u3055\u308C\u3066\u3044\u308B\u5834\u5408\u3082\u3042\u308A\u307E\u3059\u306E\u3067\u3001\u305D\u3061\u3089\u3082\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002 ",
    React.createElement("br", null),
    React.createElement("b", { className: "my-strong" }, "15\u5206\u5F85\u3063\u3066\u30E1\u30FC\u30EB\u304C\u6765\u306A\u3044\u5834\u5408"),
    "\u306F\u5225\u306E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3067\u518D\u767B\u9332\u3057\u3066\u304F\u3060\u3055\u3044\u3002 \u307E\u305F\u306F\u3001",
    React.createElement("a", { href: "mailto:info@tryupdance.com", target: "_blank", rel: "noopener noreferrer" }, "info@tryupdance.com"),
    "\u307E\u3067\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002",
    React.createElement("br", null),
    React.createElement("br", null),
    "\u3088\u308D\u3057\u3051\u308C\u3070\u3054\u4F53\u9A13\u306E\u524D\u306BTryUpDance\u306E\u30EC\u30C3\u30B9\u30F3\u306E\u69D8\u5B50\u3092\u3054\u89A7\u304F\u3060\u3055\u3044\uFF01",
    React.createElement("br", null),
    React.createElement("a", { href: "https://youtu.be/JRABgSB72Oo" }, "\u52D5\u753B\u306F\u3053\u3061\u3089"))) : (React.createElement(Form, { loading: props.loading, onSubmit: props.handleSubmit, error: !!props.errorType },
    React.createElement(Ref, { innerRef: props.formRef },
        React.createElement(Message, { error: true }, props.errorType === "failFetchClass" ? ("クラス情報の取得に失敗しました。時間を開けて再度お試しください。") : props.errorType === "failFetchClassSchedule" ? ("レッスン情報の取得に失敗しました。時間を開けて再度お試しください。") : props.errorType === "noClass" ? ("クラスを選択してください。") : props.errorType === "noClassSchedule" ? ("レッスンを選択してください。") : props.errorType === "email" ? ("メールアドレスが不正です。打ち間違えてないかどうかご確認していただくか、別のアドレスをご入力ください。") : (React.createElement(Fragment, null,
            "\u30D5\u30A9\u30FC\u30E0\u9001\u4FE1\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002",
            React.createElement("br", null),
            "\u518D\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002")))),
    React.createElement(Header, { className: "my-form-header" }, "1. \u3054\u5E0C\u671B\u306E\u30AF\u30E9\u30B9\u3092\u9078\u629E"),
    React.createElement(Accordion, { fluid: true, exclusive: false, panels: [
            {
                key: 1,
                title: {
                    content: (React.createElement("span", null,
                        "\u66DC\u65E5\u3067\u7D5E\u308A\u8FBC\u3080",
                        props.dateConditionInfo.filter((c) => c.checked).length === 0 ? (React.createElement(Label, { className: "my-label", basic: true, size: "mini", onClick: (e) => {
                                e.stopPropagation();
                                props.handleClassBulkConditionChange("date", true);
                            } }, "\u3059\u3079\u3066\u30C1\u30A7\u30C3\u30AF")) : (React.createElement(Label, { className: "my-label", basic: true, size: "mini", onClick: (e) => {
                                e.stopPropagation();
                                props.handleClassBulkConditionChange("date", false);
                            } }, "\u3059\u3079\u3066\u30AF\u30EA\u30A2")))),
                },
                content: {
                    content: (React.createElement(Form.Group, { grouped: true }, props.dateConditionInfo.map((c) => (React.createElement(Form.Checkbox, { key: c.value, label: `${c.value} (${c.count})`, checked: c.checked, onChange: props.handleClassConditionChange("date", c.value) }))))),
                },
            },
            {
                key: 2,
                title: {
                    content: (React.createElement("span", null,
                        "\u30B8\u30E3\u30F3\u30EB\u3067\u7D5E\u308A\u8FBC\u3080",
                        props.jenreConditionInfo.filter((c) => c.checked).length === 0 ? (React.createElement(Label, { className: "my-label", basic: true, size: "mini", onClick: (e) => {
                                e.stopPropagation();
                                props.handleClassBulkConditionChange("jenre", true);
                            } }, "\u3059\u3079\u3066\u30C1\u30A7\u30C3\u30AF")) : (React.createElement(Label, { className: "my-label", basic: true, size: "mini", onClick: (e) => {
                                e.stopPropagation();
                                props.handleClassBulkConditionChange("jenre", false);
                            } }, "\u3059\u3079\u3066\u30AF\u30EA\u30A2")))),
                },
                content: {
                    content: (React.createElement(Form.Group, { grouped: true }, props.jenreConditionInfo.map((c) => (React.createElement(Form.Checkbox, { key: c.value, label: `${c.value} (${c.count})`, checked: c.checked, onChange: props.handleClassConditionChange("jenre", c.value) }))))),
                },
            },
            {
                key: 3,
                title: {
                    content: (React.createElement("span", null,
                        "\u5834\u6240\u3067\u7D5E\u308A\u8FBC\u3080",
                        props.locationConditionInfo.filter((c) => c.checked).length === 0 ? (React.createElement(Label, { className: "my-label", basic: true, size: "mini", onClick: (e) => {
                                e.stopPropagation();
                                props.handleClassBulkConditionChange("location", true);
                            } }, "\u3059\u3079\u3066\u30C1\u30A7\u30C3\u30AF")) : (React.createElement(Label, { className: "my-label", basic: true, size: "mini", onClick: (e) => {
                                e.stopPropagation();
                                props.handleClassBulkConditionChange("location", false);
                            } }, "\u3059\u3079\u3066\u30AF\u30EA\u30A2")))),
                },
                content: {
                    content: (React.createElement(Form.Group, { grouped: true }, props.locationConditionInfo.map((c) => (React.createElement(Form.Checkbox, { key: c.value, label: `${c.value} (${c.count})`, checked: c.checked, onChange: props.handleClassConditionChange("location", c.value) }))))),
                },
            },
            {
                key: 4,
                title: {
                    content: (React.createElement("span", null,
                        "\u30EC\u30D9\u30EB\u3067\u7D5E\u308A\u8FBC\u3080",
                        props.levelConditionInfo.filter((c) => c.checked).length === 0 ? (React.createElement(Label, { className: "my-label", basic: true, size: "mini", onClick: (e) => {
                                e.stopPropagation();
                                props.handleClassBulkConditionChange("level", true);
                            } }, "\u3059\u3079\u3066\u30C1\u30A7\u30C3\u30AF")) : (React.createElement(Label, { className: "my-label", basic: true, size: "mini", onClick: (e) => {
                                e.stopPropagation();
                                props.handleClassBulkConditionChange("level", false);
                            } }, "\u3059\u3079\u3066\u30AF\u30EA\u30A2")))),
                },
                content: {
                    content: (React.createElement(Form.Group, { grouped: true }, props.levelConditionInfo.map((c) => (React.createElement(Form.Checkbox, { key: c.value, label: `${c.value} (${c.count})`, checked: c.checked, onChange: props.handleClassConditionChange("level", c.value) }))))),
                },
            },
        ] }),
    React.createElement(Divider, null),
    props.selectedClassRecords.length === 0 && !props.loading ? (React.createElement(Message, { info: true, size: "small" }, "\u6761\u4EF6\u306B\u8A72\u5F53\u3059\u308B\u30AF\u30E9\u30B9\u304C\u3042\u308A\u307E\u305B\u3093\u3002\u6761\u4EF6\u3092\u5909\u3048\u3066\u518D\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002")) : (React.createElement("p", null,
        React.createElement("b", null,
            props.selectedClassRecords.flat().length,
            " \u4EF6"),
        "\u306E\u30AF\u30E9\u30B9\u304C\u8A72\u5F53\u3057\u307E\u3057\u305F\u3002")),
    props.selectedClassRecords.map((classRecordByDayOfTheWeek, i) => (React.createElement(List, { celled: true, relaxed: true, size: "large", key: i, selection: true, className: "my-list-by-day-of-the-week" },
        React.createElement(Header, { size: "small", className: "day-of-the-week-header" },
            classRecordByDayOfTheWeek[0].date.value,
            "\u65E5"),
        classRecordByDayOfTheWeek.map((classRecord) => (React.createElement(List.Item, { key: classRecord.$id.value, icon: true, disabled: classRecord.trial_lesson_flg.value === "false", className: `${classRecord.trial_lesson_flg.value === "false" && "full-class-list-item"} ${props.selectedClassId === classRecord.$id.value && "selected-class-list-item"}`, onClick: classRecord.trial_lesson_flg.value !== "false"
                ? props.handleClassSelect(classRecord.$id.value)
                : undefined },
            React.createElement(List.Icon, { name: props.selectedClassId === classRecord.$id.value ? "check square" : "check square outline", verticalAlign: "middle" }),
            React.createElement(List.Content, null,
                React.createElement(List.Header, { className: "class-name-header" },
                    `${classRecord.jenre.value} ${classRecord.jenre_additional_message.value
                        ? `(${classRecord.jenre_additional_message.value})`
                        : ""} ${classRecord.level.value}`,
                    classRecord.trial_lesson_flg.value === "false" ? (React.createElement(Label, { color: "red", size: "mini", className: "full-icon" }, "\u6E80\u54E1\u5FA1\u793C")) : (classRecord.level.value === "超初級" && React.createElement(Icon, { name: "leaf", className: "new-class-icon" })),
                    React.createElement("span", { style: { marginLeft: "0.3em" } },
                        classRecord.area.value === "横浜" && props.area !== "横浜" && React.createElement(Label, { color: "blue" }, "\u6A2A\u6D5C"),
                        classRecord.area.value === "大宮" && props.area !== "大宮" && React.createElement(Label, { color: "olive" }, "\u5927\u5BAE"))),
                React.createElement(List.Description, { className: "my-list-description" },
                    React.createElement("div", { className: "my-user" },
                        React.createElement(Icon, { name: "user", color: "grey" }),
                        classRecord.teacher_name.value),
                    React.createElement("div", { className: "my-time" },
                        React.createElement(Icon, { name: "time", color: "grey" }),
                        `${classRecord.start_time.value}-${classRecord.end_time.value}`),
                    React.createElement("div", { className: "my-locaiton" },
                        React.createElement(Icon, { name: "map marker alternate", color: "grey" }),
                        classRecord.lesson_place.value))))))))),
    React.createElement(Ref, { innerRef: props.classScheduleRef },
        React.createElement(Header, { className: "my-form-header" }, "2. \u3054\u5E0C\u671B\u306E\u65E5\u7A0B\u3092\u9078\u629E")),
    !props.selectedClassId ? (React.createElement(Message, { info: true, size: "small" }, "\u30EC\u30C3\u30B9\u30F3\u3092\u9078\u629E\u3059\u308B\u524D\u306B\u30AF\u30E9\u30B9\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002")) : props.classScheduleLoading ? (React.createElement(Loader, { active: true, inline: "centered" }, "\u30EC\u30C3\u30B9\u30F3\u60C5\u5831\u3092\u53D6\u5F97\u4E2D...")) : props.classScheduleInfoList.length === 0 ? (React.createElement(Message, { info: true, size: "small" }, "\u6761\u4EF6\u306B\u8A72\u5F53\u3059\u308B\u30EC\u30C3\u30B9\u30F3\u304C\u3042\u308A\u307E\u305B\u3093\u3002\u6761\u4EF6\u3092\u5909\u3048\u3066\u518D\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002")) : (React.createElement(List, { celled: true, relaxed: true, size: "large", selection: true }, props.classScheduleInfoList.map((classScheduleInfo) => (React.createElement(List.Item, { key: classScheduleInfo.classScheduleRecord.id.value, icon: true, disabled: classScheduleInfo.disabled, className: `${classScheduleInfo.disabled && "full-class-list-item"} ${props.selectedClassScheduleId === classScheduleInfo.classScheduleRecord.$id.value &&
            "selected-class-list-item"}`, onClick: classScheduleInfo.disabled
            ? undefined
            : props.handleClassScheduleSelect(classScheduleInfo.classScheduleRecord.$id.value) },
        React.createElement(List.Icon, { name: props.selectedClassScheduleId === classScheduleInfo.classScheduleRecord.$id.value
                ? "check square"
                : "check square outline", verticalAlign: "middle" }),
        React.createElement(List.Content, null,
            React.createElement(List.Header, { className: "lesson-date-header" },
                format(new Date(classScheduleInfo.classScheduleRecord.date.value), "yyyy年MM月dd日"),
                classScheduleInfo.allowedTrialStudentCount <= 0 ? (React.createElement(Label, { color: "red", size: "tiny", className: "full-icon" }, "\u6E80\u54E1\u5FA1\u793C")) : (classScheduleInfo.allowedTrialStudentCount > 0 &&
                    classScheduleInfo.allowedTrialStudentCount < 5 && (React.createElement(Label, { color: classScheduleInfo.allowedTrialStudentCount >= 4
                        ? "orange"
                        : classScheduleInfo.allowedTrialStudentCount > 1
                            ? "yellow"
                            : "red", size: "tiny", className: "full-icon" },
                    "\u3042\u3068",
                    classScheduleInfo.allowedTrialStudentCount,
                    "\u540D\u3067\u6E80\u54E1")))),
            React.createElement(List.Description, { className: classScheduleInfo.cautionMessages.length > 0 ? "class-schedule-with-message" : "" }, classScheduleInfo.cautionMessages.length > 0 &&
                classScheduleInfo.cautionMessages.reduce((prev, curr, i) => [prev, React.createElement("br", { key: i }), curr])))))))),
    React.createElement(Header, { className: "my-form-header" }, "3. \u304A\u5BA2\u69D8\u306E\u60C5\u5831\u3092\u5165\u529B"),
    React.createElement(Form.Field, { required: true },
        React.createElement("label", null, "\u304A\u540D\u524D (\u5FC5\u9808)"),
        React.createElement(Form.Input, { type: "text", required: true, ...props.nameProps })),
    React.createElement(Form.Field, { required: true },
        React.createElement("label", null, "E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9 (\u5FC5\u9808)"),
        React.createElement(Form.Input, { type: "email", placeholder: "\u4F8B\uFF1A tryupdance@example.com", required: true, ...props.emailProps }),
        React.createElement(Message, { size: "small" },
            React.createElement("p", null, " \u3054\u5165\u529B\u9802\u3044\u305F\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306B\u30EC\u30C3\u30B9\u30F3\u306E\u8A73\u7D30\u60C5\u5831\u3092\u304A\u9001\u308A\u3057\u307E\u3059\u3002"),
            React.createElement("p", null, " \u30AD\u30E3\u30EA\u30A2\u30E1\u30FC\u30EB\u306F\u5C4A\u304B\u306A\u3044\u53EF\u80FD\u6027\u304C\u9AD8\u3044\u306E\u3067\u3001Gmail \u3084 Outlook\u3001iCloud \u30E1\u30FC\u30EB\u7B49\u3092\u63A8\u5968\u3057\u3066\u304A\u308A\u307E\u3059\u3002"))),
    React.createElement(Form.Field, { required: true },
        React.createElement("label", null, "\u96FB\u8A71\u756A\u53F7 (\u5FC5\u9808)"),
        React.createElement(Form.Input, { type: "tel", placeholder: "\u4F8B\uFF1A xxx-xxxx-xxxx", required: true, ...props.telProps })),
    React.createElement(Divider, { hidden: true }),
    React.createElement(Form.Field, null,
        React.createElement(Form.Checkbox, { error: props.privacyPolicyError && { content: "この項目は必須です", pointing: "below" }, required: true, label: React.createElement("label", null,
                React.createElement("a", { target: "_blank", rel: "noopener noreferrer", href: "./privacy-policy.html" }, "\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u30DD\u30EA\u30B7\u30FC"),
                "\u306B\u540C\u610F\u3059\u308B"), ...props.privacyPolicyProps })),
    React.createElement(Divider, { hidden: true }),
    React.createElement(Button, { type: "submit", positive: true, className: "my-submit-button" }, "\u304A\u7533\u3057\u8FBC\u307F\u3092\u78BA\u5B9A\u3059\u308B")))));
const StyledComponent = styled(Component) `
  text-align: left;
  font-family: "Libre Franklin", "Kosugi Maru", sans-serif !important;

  .my-form-header {
    border-bottom: 1px solid rgb(66, 191, 0);
  }

  && .my-list-by-day-of-the-week {
    margin-top: 2em;
  }

  && .my-label {
    margin-left: 1em;
  }

  &&& .class-name-header {
    display: flex;
    align-items: center;
  }

  &&& .my-list-description {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
  }

  .my-list-description div {
    width: 50%;
  }
  .my-list-description .my-user {
    width: 100%;
  }

  && .day-of-the-week-header {
    margin-bottom: 0;
  }

  && .new-class-icon {
    color: #42bf00;
    margin-left: 0.5em;
  }

  && .full-icon {
    margin-left: 0.5em;
  }

  &&& .full-class-list-item {
    background-color: lightgray;
  }

  &&&&& .selected-class-list-item {
    background-color: rgba(67, 191, 0, 0.392);
  }

  &&& .lesson-date-header {
    display: flex;
    align-items: center;
  }

  &&& .class-schedule-with-message {
    margin-top: 0.5em;
  }

  &&& .my-submit-button {
    background-color: rgb(66, 191, 0);
  }

  &&& .my-strong {
    color: #801237;
    text-decoration: underline;
  }
`;
const Container = (props) => {
    var _a, _b, _c;
    const [dateConditionInfo, setDateConditionInfo] = useState([
        { value: "月曜", checked: true, count: 0 },
        { value: "火曜", checked: true, count: 0 },
        { value: "水曜", checked: true, count: 0 },
        { value: "木曜", checked: true, count: 0 },
        { value: "金曜", checked: true, count: 0 },
        { value: "土曜", checked: true, count: 0 },
        { value: "日曜", checked: true, count: 0 },
    ]);
    const [jenreConditionInfo, setJenreConditionInfo] = useState([]);
    const [locationConditionInfo, setLocationConditionInfo] = useState([]);
    const [levelConditionInfo, setLevelConditionInfo] = useState([
        { value: "超初級", checked: true, count: 0 },
        { value: "初級", checked: true, count: 0 },
        { value: "初中級", checked: true, count: 0 },
        { value: "中級", checked: true, count: 0 },
    ]);
    const [loading, setLoading] = useState(false);
    const [classScheduleLoading, setClassScheduleLoading] = useState(false);
    const [classRecords, setClassRecords] = useState([]);
    const classId = useQueryString("id");
    const [selectedClassId, setSelectedClassId] = useState(classId !== null && classId !== void 0 ? classId : "");
    const [classScheduleInfoRecordsList, setClassScheduleInfoRecordsList] = useState({
        classScheduleRecords: [],
        substitutedTeacherRecords: [],
        classCancelRecords: [],
        datetimeModificationRecords: [],
        studioModificationRecords: [],
        trialStudentCountByClassSchedule: {},
    });
    const [selectedClassScheduleId, setSelectedClassScheduleId] = useState();
    const { inputProps: nameProps } = useTextInput((_a = useQueryString("name")) !== null && _a !== void 0 ? _a : "");
    const { inputProps: emailProps } = useTextInput((_b = useQueryString("email")) !== null && _b !== void 0 ? _b : "");
    const { inputProps: telProps } = useTextInput((_c = useQueryString("tel")) !== null && _c !== void 0 ? _c : "");
    const { inputProps: privacyPolicyProps } = useCheckbox(false);
    const [errorType, setErrorType] = useState();
    const [success, setSuccess] = useState(false);
    const [privacyPolicyError, setPrivacyPolicyError] = useState(false);
    const formRef = useRef(null);
    const classScheduleRef = useRef(null);
    useEffect(() => {
        // query stringとしてidが指定された場合は、レッスンのロード等を待ってからスクロールしないと、スクロール位置がずれる
        // レッスン数が0より大きいときにのみスクロールすることで、レッスン取得エラー時のスクロールと競合しないようにしている
        if (!loading &&
            !classScheduleLoading &&
            classScheduleInfoRecordsList.classScheduleRecords.length > 0 &&
            selectedClassId &&
            classScheduleRef.current) {
            classScheduleRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
        }
    }, [
        classId,
        classRecords.length,
        classScheduleInfoRecordsList.classScheduleRecords.length,
        classScheduleLoading,
        loading,
        selectedClassId,
    ]);
    useEffect(() => {
        // ロード中にスクロールすると位置がずれる
        if (errorType && formRef.current && !loading) {
            formRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    }, [errorType, loading]);
    useEffect(() => {
        (async () => {
            setLoading(true);
            try {
                const classRecords = (await axios.get(`https://zzifn6a86g.execute-api.ap-northeast-1.amazonaws.com/Prod?area=${props.area}`)).data;
                const classCountByDate = {};
                const classCountByJenre = {};
                const classCountByLocation = {};
                const classCountByLevel = {};
                classRecords.forEach((classRecord) => {
                    var _a, _b, _c, _d;
                    classCountByDate[classRecord.date.value] = ((_a = classCountByDate[classRecord.date.value]) !== null && _a !== void 0 ? _a : 0) + 1;
                    classCountByJenre[classRecord.jenre.value] = ((_b = classCountByJenre[classRecord.jenre.value]) !== null && _b !== void 0 ? _b : 0) + 1;
                    classCountByLocation[classRecord.lesson_place.value] =
                        ((_c = classCountByLocation[classRecord.lesson_place.value]) !== null && _c !== void 0 ? _c : 0) + 1;
                    classCountByLevel[classRecord.level.value] = ((_d = classCountByLevel[classRecord.level.value]) !== null && _d !== void 0 ? _d : 0) + 1;
                });
                setDateConditionInfo((prev) => prev.map((p) => { var _a; return ({ ...p, count: (_a = classCountByDate[p.value]) !== null && _a !== void 0 ? _a : 0 }); }));
                setJenreConditionInfo(Object.entries(classCountByJenre).map(([jenre, count]) => ({ value: jenre, count, checked: true })));
                setLocationConditionInfo(Object.entries(classCountByLocation).map(([location, count]) => ({ value: location, count, checked: true })));
                setLevelConditionInfo((prev) => prev.map((p) => { var _a; return ({ ...p, count: (_a = classCountByLevel[p.value]) !== null && _a !== void 0 ? _a : 0 }); }));
                setClassRecords(classRecords);
            }
            catch (_a) {
                setErrorType("failFetchClass");
            }
            finally {
                setLoading(false);
            }
        })();
    }, [props.area]);
    useEffect(() => {
        (async () => {
            if (selectedClassId) {
                setClassScheduleLoading(true);
                try {
                    setClassScheduleInfoRecordsList((await axios.get("https://36hohc5sf0.execute-api.ap-northeast-1.amazonaws.com/Prod", {
                        params: { class_id: selectedClassId },
                    })).data);
                    if (classId) {
                        dataLayer.push({
                            event: "trial-lesson-form-progress",
                            "form-progress": "auto-set-class",
                        });
                    }
                }
                catch (_a) {
                    setErrorType("failFetchClassSchedule");
                }
                finally {
                    setClassScheduleLoading(false);
                }
            }
        })();
    }, [classId, selectedClassId]);
    const handleClassConditionChange = useCallback((type, value) => () => {
        switch (type) {
            case "date": {
                setDateConditionInfo((prev) => prev.map((p) => (p.value === value ? { ...p, checked: !p.checked } : p)));
                break;
            }
            case "jenre": {
                setJenreConditionInfo((prev) => prev.map((p) => (p.value === value ? { ...p, checked: !p.checked } : p)));
                break;
            }
            case "location": {
                setLocationConditionInfo((prev) => prev.map((p) => (p.value === value ? { ...p, checked: !p.checked } : p)));
                break;
            }
            case "level": {
                setLevelConditionInfo((prev) => prev.map((p) => (p.value === value ? { ...p, checked: !p.checked } : p)));
                break;
            }
        }
    }, []);
    const handleClassBulkConditionChange = useCallback((type, checkAll) => {
        switch (type) {
            case "date": {
                setDateConditionInfo((prev) => prev.map((p) => ({ ...p, checked: checkAll })));
                break;
            }
            case "jenre": {
                setJenreConditionInfo((prev) => prev.map((p) => ({ ...p, checked: checkAll })));
                break;
            }
            case "location": {
                setLocationConditionInfo((prev) => prev.map((p) => ({ ...p, checked: checkAll })));
                break;
            }
            case "level": {
                setLevelConditionInfo((prev) => prev.map((p) => ({ ...p, checked: checkAll })));
                break;
            }
        }
    }, []);
    const selectedClassRecords = useMemo(() => classRecords
        .filter((c) => {
        var _a, _b, _c, _d;
        return ((_a = dateConditionInfo.find((d) => d.value === c.date.value)) === null || _a === void 0 ? void 0 : _a.checked) &&
            ((_b = jenreConditionInfo.find((d) => d.value === c.jenre.value)) === null || _b === void 0 ? void 0 : _b.checked) &&
            ((_c = locationConditionInfo.find((d) => d.value === c.lesson_place.value)) === null || _c === void 0 ? void 0 : _c.checked) &&
            ((_d = levelConditionInfo.find((d) => d.value === c.level.value)) === null || _d === void 0 ? void 0 : _d.checked);
    })
        .sort((a, b) => (compareByDayOfTheWeekAndStartTime(a, b) ? 1 : -1))
        .reduce((acc, classRecords) => {
        acc[DAY_OF_THE_WEEK_DIC[classRecords.date.value]].push(classRecords);
        return acc;
    }, [[], [], [], [], [], [], []])
        // レッスンがない曜日は消す
        .filter((e) => e.length !== 0), [classRecords, dateConditionInfo, jenreConditionInfo, levelConditionInfo, locationConditionInfo]);
    const handleClassSelect = useCallback((classId) => () => {
        setSelectedClassId(classId);
        setSelectedClassScheduleId(undefined);
        dataLayer.push({
            event: "trial-lesson-form-progress",
            "form-progress": "class-selected",
        });
    }, []);
    const handleClassScheduleSelect = useCallback((classScheduleId) => () => {
        setSelectedClassScheduleId(classScheduleId);
        dataLayer.push({
            event: "trial-lesson-form-progress",
            "form-progress": "class-schedule-selected",
        });
    }, []);
    const classScheduleInfoList = useMemo(() => classScheduleInfoRecordsList.classScheduleRecords.map((classScheduleRecord) => {
        // 休講の場合は他の条件は無視する
        if (classScheduleInfoRecordsList.classCancelRecords.find((c) => c.canceled_class_schedule_id.value === classScheduleRecord.$id.value)) {
            return {
                classScheduleRecord,
                disabled: true,
                cautionMessages: ["このレッスンは休講です"],
                allowedTrialStudentCount: -1,
            };
        }
        const cautionMessages = [];
        const substitutedTeacherInfo = classScheduleInfoRecordsList.substitutedTeacherRecords.find((s) => s.substituted_teacher_target_class_schedule_id.value === classScheduleRecord.$id.value);
        if (substitutedTeacherInfo) {
            cautionMessages.push(`このレッスンは講師が${substitutedTeacherInfo.substitute_teacher_name.value}に変更になります。`);
        }
        const modifiedStudioInfo = classScheduleInfoRecordsList.studioModificationRecords.find((c) => c.temporal_change_class_schedule_id.value === classScheduleRecord.$id.value);
        if (modifiedStudioInfo) {
            cautionMessages.push(`このレッスンはスタジオが${modifiedStudioInfo.temporal_change_after_lesson_place.value}の${modifiedStudioInfo.temporal_change_after_studio_name.value}に変更になります。`);
        }
        const modifiedDatetimeInfo = classScheduleInfoRecordsList.datetimeModificationRecords.find((c) => c.class_schedule_id.value === classScheduleRecord.$id.value);
        if (modifiedDatetimeInfo) {
            cautionMessages.push(`このレッスンは日程が${format(new Date(modifiedDatetimeInfo.before_date.value), "yyyy年MM月dd日")} ${modifiedDatetimeInfo.before_start_time.value}-${modifiedDatetimeInfo.before_end_time.value}から${format(new Date(modifiedDatetimeInfo.after_date.value), "yyyy年MM月dd日")} ${modifiedDatetimeInfo.after_start_time.value}-${modifiedDatetimeInfo.after_end_time.value}に変更になります。`);
        }
        const allowedTrialStudentCount = Number(classScheduleRecord.max_trial_student_count.value) -
            classScheduleInfoRecordsList.trialStudentCountByClassSchedule[classScheduleRecord.$id.value];
        return {
            classScheduleRecord,
            disabled: allowedTrialStudentCount <= 0,
            cautionMessages,
            allowedTrialStudentCount,
        };
    }), [
        classScheduleInfoRecordsList.classCancelRecords,
        classScheduleInfoRecordsList.classScheduleRecords,
        classScheduleInfoRecordsList.datetimeModificationRecords,
        classScheduleInfoRecordsList.studioModificationRecords,
        classScheduleInfoRecordsList.substitutedTeacherRecords,
        classScheduleInfoRecordsList.trialStudentCountByClassSchedule,
    ]);
    const handleSubmit = useCallback(async () => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        dataLayer.push({
            event: "trial-lesson-form-progress",
            "form-progress": "push-form-submit-button",
        });
        if (!selectedClassId) {
            setErrorType("noClass");
            return;
        }
        if (!selectedClassScheduleId) {
            setErrorType("noClassSchedule");
            return;
        }
        if (!privacyPolicyProps.checked) {
            setPrivacyPolicyError(true);
            return;
        }
        dataLayer.push({
            event: "trial-lesson-form-progress",
            "form-progress": "push-form-submit-started",
        });
        setLoading(true);
        try {
            const res = (await axios.post("https://r2imrlb870.execute-api.ap-northeast-1.amazonaws.com/Prod/", {
                name: nameProps.value,
                email: emailProps.value,
                tel: telProps.value.replaceAll("-", ""),
                lessonId: selectedClassScheduleId,
                classId: selectedClassId,
                gaTag: (_c = (_b = (_a = document.cookie) === null || _a === void 0 ? void 0 : _a.split(";")) === null || _b === void 0 ? void 0 : _b.find((c) => c.includes("_gcl_aw="))) !== null && _c !== void 0 ? _c : "",
                cookie: (_d = document.cookie) !== null && _d !== void 0 ? _d : "",
                utmSource: (_e = localStorage.getItem("utm_source")) !== null && _e !== void 0 ? _e : "",
                utmCampaign: (_f = localStorage.getItem("utm_campaign")) !== null && _f !== void 0 ? _f : "",
                utmContent: (_g = localStorage.getItem("utm_content")) !== null && _g !== void 0 ? _g : "",
                utmMedia: (_h = localStorage.getItem("utm_media")) !== null && _h !== void 0 ? _h : "",
            })).data;
            setSuccess(true);
            localStorage.clear();
            if (res.isNew) {
                dataLayer.push({
                    event: "trial-lesson-form-submission",
                    "form-status": "success",
                    "record-id": res.createdRecordId,
                });
                fbq("track", "SubmitApplication");
            }
        }
        catch (e) {
            if (axios.isAxiosError(e) && ((_j = e.response) === null || _j === void 0 ? void 0 : _j.data) === "email is not valid") {
                setErrorType("email");
            }
            else {
                setErrorType("unknown");
            }
            dataLayer.push({
                event: "trial-lesson-form-submission",
                "form-status": "failed",
            });
        }
        finally {
            setLoading(false);
        }
    }, [
        emailProps.value,
        nameProps.value,
        privacyPolicyProps.checked,
        selectedClassId,
        selectedClassScheduleId,
        telProps.value,
    ]);
    return (React.createElement(StyledComponent, { area: props.area, dateConditionInfo: dateConditionInfo, jenreConditionInfo: jenreConditionInfo, locationConditionInfo: locationConditionInfo, levelConditionInfo: levelConditionInfo, loading: loading, handleClassConditionChange: handleClassConditionChange, handleClassBulkConditionChange: handleClassBulkConditionChange, handleClassSelect: handleClassSelect, selectedClassRecords: selectedClassRecords, selectedClassId: selectedClassId, handleClassScheduleSelect: handleClassScheduleSelect, selectedClassScheduleId: selectedClassScheduleId, classScheduleInfoList: classScheduleInfoList, nameProps: nameProps, emailProps: emailProps, telProps: telProps, privacyPolicyProps: privacyPolicyProps, classScheduleLoading: classScheduleLoading, formRef: formRef, classScheduleRef: classScheduleRef, handleSubmit: handleSubmit, errorType: errorType, success: success, privacyPolicyError: privacyPolicyError }));
};
export default Container;
